module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADlSURBVHgBjZHNDYIwFMf7XvXuACbiyZh40EQ96whOoBvoBuIGjgATMIJ3MMGDCeoFSRyAu9LaIihgUV7S9H39/m1fwfV8jSF1keBq0GmapIK559uccaZHj2iGDOiOcNIQCUMWKsKGcDVaoxYyzt+nyoLj+ZMy2L74/QRO+rmJo25LF84mTSJSyz76fRVMubjtB95IFtKE4wU6AqzjAEgY3aPpuNc+5GDx1Cz8as2YSqROSSiHrIK/BKTtT8EWCCyT8JrsmgpWCsQiXmAAQO5HuBjYsNtaFHuVAkWRMvivSRG5fvU8Aa2/h2mzfvi/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.png
// module id = 1192
// module chunks = 3